import { render, staticRenderFns } from "./addGoodWaiku.vue?vue&type=template&id=c2da99bc&scoped=true&"
import script from "./addGoodWaiku.vue?vue&type=script&lang=js&"
export * from "./addGoodWaiku.vue?vue&type=script&lang=js&"
import style0 from "./addGoodWaiku.vue?vue&type=style&index=0&id=c2da99bc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2da99bc",
  null
  
)

export default component.exports